import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DataLayer } from '../../models/data-layer';
import { CrudService } from '../crud.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataLayerService extends CrudService<DataLayer> {
  protected basePath = 'dataLayer'; // Specific for DataLayerService
  public instanceType = 'dataLayer'; // Used in base service for constructing URLs

  async getByParentIds(
    parentIds: string[],
    typeYears: Record<string, string[]>
  ) {
    const headers = new HttpHeaders({
      'X-Parent-Ids': JSON.stringify(parentIds),
      'X-Allowed-Years': JSON.stringify(typeYears),
    });
    return await lastValueFrom(
      this.http.get<{ [key: string]: DataLayer }>(
        `${this.getBaseUrl()}/categories`,
        { headers: headers }
      )
    );
  }
  constructor(http: HttpClient) {
    super(http);
  }
}
